import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"วีซ่านักเรียน Non-ED — เรียนไทยตั้งแต่ภาษาถึงปริญญาเอก","metaTitle":"Non-ED Student Visa Thailand — วีซ่านักเรียนครบทุกระดับ | NYC","metaDesc":"บริการยื่นวีซ่านักเรียน Non-ED เรียนภาษาไทย/ต่างประเทศ ปริญญาตรี-เอก โรงเรียนสอนศิลปะ พร้อม 90-day report คร — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน"},"en":{"h1":"Non-ED Student Visa Thailand — Language, School, University","metaTitle":"Thailand Non-ED Student Visa — Language / Degree / Vocational | NYC","metaDesc":"End-to-end Non-ED student visa service — Thai language, K-12 international, BA/MA/PhD, vocational. . — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/en/thai-visa/education")({
  head: () => {
    const url = `${SEO_SITE}/en/thai-visa/education`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/thai-visa/education", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/thai-visa/education", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/thai-visa/education", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/thai-visa/education", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/thai-visa/education", "/en/thai-visa/education")],
    };
  },
  component: () => <SubServicePage slug="thai-visa/education" locale="en" />,
});
